/* eslint-disable no-alert */
import React from "react";
import { useQuery, useMutation } from "@apollo/client";
import { gql } from "graphql-tag";
import { updateList as updateListType, getListForAdmin } from "types/gql-types";
import logger from "services/logger";
import { ServerError, LoadingSpinner } from "components/graphql-views";
import { useSnackbar } from "components/haven-design/snackbar";
import ListsForm, { InterestList, formSchema } from "./form";

const LIST = gql`
  query getListForAdmin($id: ID!) {
    interestList(id: $id) {
      id
      isArchived
      name
      type
      email
      phone
      organizationId
      hasPaperDisclaimer
      address {
        name
        address1
        address2
        city
        state
        zip
      }
    }
  }
`;

const UPDATE_LIST = gql`
  mutation updateList($id: ID!, $data: InterestListInput!) {
    updateInterestList(id: $id, data: $data) {
      id
      name
    }
  }
`;

const UpdateList: React.FC<{ interestListId: string }> = ({ interestListId: listId }) => {
  const { openSnackbar } = useSnackbar();
  const [sending, setSending] = React.useState(false);
  const { loading, error, data } =
    useQuery<getListForAdmin>(LIST, { variables: { id: listId }, fetchPolicy: "cache-and-network" });
  const [updateUser] = useMutation<updateListType>(UPDATE_LIST);

  if (error) return <ServerError desc={error.message} />;
  if (loading) return <LoadingSpinner />;
  if (!data) return null;

  // casting strips __typename from the appollo response data
  // later this will also take null data and make it an empty string
  const list = formSchema.cast(data.interestList);

  const submitForm = (updateList: any, formData: InterestList) => {
    if (!listId) {
      alert("Invalid URL");
      return;
    }

    setSending(true);
    updateList({ variables: { id: listId, data: formData } })
      .then(() => {
        openSnackbar({ message: "Saved", status: "success" });
        setSending(false);
      })
      .catch((err: any) => {
        logger.sendError(err);
        openSnackbar({ message: "Could not save list", status: "error" });
        setSending(false);
      });
  };
  return (
    <>
      <ListsForm
        listId={listId}
        formType="update"
        // @ts-ignore
        initialData={list}
        sending={sending}
        handleSubmit={(submitData: any) => {
          submitForm(updateUser, submitData);
        }}
      />
    </>);
};

export default UpdateList;
